import * as React from 'react';

const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.5" stroke="#E4E7EC" />
    <path
      d="M8.5625 6.91406C8.91406 6.70312 9.35938 6.70312 9.71094 6.9375L16.4609 11.0391C16.7891 11.25 17 11.625 17 12C17 12.3984 16.7891 12.7734 16.4609 12.9609L9.71094 17.0859C9.35938 17.2969 8.91406 17.3203 8.5625 17.1094C8.21094 16.9219 8 16.5469 8 16.125V7.875C8 7.47656 8.21094 7.10156 8.5625 6.91406ZM9.3125 7.57031C9.19531 7.5 9.05469 7.5 8.9375 7.57031C8.82031 7.61719 8.75 7.75781 8.75 7.875V16.125C8.75 16.2656 8.82031 16.4062 8.9375 16.4531C9.05469 16.5234 9.19531 16.5234 9.3125 16.4531L16.0625 12.3281C16.1797 12.2578 16.25 12.1406 16.25 12C16.25 11.8828 16.1797 11.7656 16.0625 11.6953L9.3125 7.57031Z"
      fill="#293055"
    />
  </svg>
);
export default PlayIcon;
